import React from 'react';
import { LightbulbIcon, ShieldCheckIcon, TrendingUpIcon, HandshakeIcon } from 'lucide-react';
import { values } from '../data/content';
import { Reveal } from './Reveal';
const icons = [LightbulbIcon, ShieldCheckIcon, TrendingUpIcon, HandshakeIcon];
export function ValueSection() {
  return <section id="nosotros" className="mx-auto max-w-7xl scroll-mt-24 px-6 py-24 lg:px-10 lg:py-32" data-id="element-161" data-mp="ievzyxyt6vps">
      <Reveal className="max-w-2xl" data-id="element-162" data-mp="dfruahb3fg47">
        <p className="text-[13px] font-medium uppercase tracking-[0.16em] text-accent" data-id="element-163" data-mp="dguiuiky16gy">Nosotros</p>
        <h2 className="mt-4 text-4xl font-semibold leading-[1.1] tracking-[-0.03em] text-ink lg:text-5xl" data-id="element-164" data-mp="8myp5sbpq5rl">
          ¿Por qué elegir Almaria?
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-165" data-mp="3uw179lnr2ygm">
          Un equipo pequeño y senior, con procesos claros y una obsesión por entregar trabajo que
          funcione en producción y sostenga el crecimiento de tu negocio.
        </p>
      </Reveal>

      <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-166" data-mp="3lx628cwfzuew">
        {values.map((value, i) => {
        const Icon = icons[i];
        return <li key={value.title} data-id="element-167" data-mp="1o1l8ojtqh3j6" data-mpi={i}>
              <Reveal delay={i * 0.08} data-id="element-168" data-mp="1o2mot2plwg7r">
                <article className="group h-full rounded-3xl border border-slate-200/80 bg-white p-7 shadow-soft transition-all duration-300 hover:-translate-y-1.5 hover:border-accent/30 hover:shadow-lift" data-id="element-169" data-mp="1a9okgqv6rds2">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-accent-soft text-accent transition-colors duration-300 group-hover:bg-accent group-hover:text-white" data-id="element-170" data-mp="2202w0gfq8e0k">
                    <Icon className="h-5 w-5" strokeWidth={1.6} aria-hidden="true" data-id="element-171" data-mp="1syl6k7gfizz7" />
                  </span>
                  <h3 className="mt-6 text-lg font-semibold tracking-[-0.01em] text-ink" data-id="element-172" data-mp="1xxelm4bd6z1h">
                    {value.title}
                  </h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-173" data-mp="hmu1xzhxioh8">
                    {value.description}
                  </p>
                </article>
              </Reveal>
            </li>;
      })}
      </ul>
    </section>;
}